import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v1/power-bi/embed-urls', {
      params
    });
  },
  get(params = {}) {
    return axios.get('/v1/power-bi/embed-url', {
      params
    });
  },
  createOrUpdate(data, params = {}) {
    return axios.post(`/v1/power-bi/embed-urls/`, data, {
      params
    });
  }
};
